function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import Env, { compareVersion } from './util.env';
import Didasdk from './util.didasdk';

var FPsdk = /*#__PURE__*/function () {
  function FPsdk() {
    _classCallCheck(this, FPsdk);

    this.__isinit = false;
  }

  _createClass(FPsdk, [{
    key: "__init",
    value: function __init() {
      this.__isinit = true;
      window._smReadyFuncs = [];
      window.SMSdk = {
        ready: function ready(fn) {
          fn && window._smReadyFuncs.push(fn);
        }
      }; // 1. 通用配置项

      window._smConf = {
        organization: 'ZaY7P36K6ysoA4iZylFr',
        // 必填，组织标识，邮件中 organization 项
        staticHost: 'static.fengkongcloud.com' // 2.连接海外机房特殊配置项，仅供设备数据上报海外机房客户使用

      };

      var url = function () {
        var originHost = 'static2.fengkongcloud.com';
        var isHttps = document.location.protocol === 'https:';
        var protocol = isHttps ? 'https://' : 'http://';
        var fpJsPath = '/fpv2.js';
        var url = protocol + window._smConf.staticHost + fpJsPath;
        var ua = navigator.userAgent.toLowerCase();
        var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
        var isLowIE = /msie\s[678]\.0/.test(ua);

        if (isHttps && isWinXP && isLowIE) {
          url = protocol + originHost + fpJsPath;
        }

        return url;
      }();

      var sm = document.createElement('script');
      var s = document.getElementsByTagName('script')[0];
      sm.src = url;
      s.parentNode.insertBefore(sm, s);
    }
    /**
     * cb 业务逻辑
     * 使用数美设备标识逻辑
     */

  }, {
    key: "dealSmDeviceId",
    value: function dealSmDeviceId(cb) {
      try {
        if (!this.__isinit) {
          this.__init();
        }

        var smDeviceId = '';
        window.SMSdk.ready(function () {
          smDeviceId = window.SMSdk.getDeviceId ? window.SMSdk.getDeviceId() : smDeviceId;
          cb && cb(smDeviceId);
        });
      } catch (e) {
        cb && cb('');
        console.log('获取deviceId失败');
      }
    }
  }]);

  return FPsdk;
}();

var $deviceId = '';
var fpsdk = new FPsdk();
export default fpsdk;
export function getSMDeviceId() {
  return new Promise(function (resolve) {
    if ($deviceId) {
      resolve($deviceId);
      return;
    }

    try {
      if (Env.inApplication && compareVersion(Env.curAppVersion, '8.10.0') >= 0) {
        Didasdk.ready(function () {
          // 获取App数美id
          Didasdk.callHandler('getSMDeviceId', null).then(function (res) {
            try {
              console.info('[util.fp] [getSMDeviceId] getSMDeviceId res => ' + "(".concat(res, ")"));
              $deviceId = JSON.parse(res).device_id;
            } catch (e) {
              console.error('[util.fp] [getSMDeviceId] getSMDeviceId 1 => \n', e);
            }

            if ($deviceId) {
              resolve($deviceId);
            } else {
              fpsdk.dealSmDeviceId(function (deviceId) {
                if (deviceId) {
                  $deviceId = deviceId;
                } else {
                  console.info('[util.fp] [getSMDeviceId] dealSmDeviceId 没有deviceId 1');
                }

                resolve($deviceId);
              });
            }
          });
        });
      } else {
        fpsdk.dealSmDeviceId(function (deviceId) {
          if (deviceId) {
            $deviceId = deviceId;
          } else {
            console.info('[util.fp] [getSMDeviceId] dealSmDeviceId 没有deviceId 2');
          }

          resolve($deviceId);
        });
      }
    } catch (e) {
      console.error('[util.fp] [getSMDeviceId] 2 => \n', e);
      resolve($deviceId);
    }
  });
}